module.exports = __webpack_public_path__ + "img/ic_store_function_img4.1f435cc6.png";